/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md.
 */

/**
 * @module image/imagetextalternative/imagetextalternativecommand
 */

import Command from '@ckeditor/ckeditor5-core/src/command';
import { isImage } from '../image/utils';
import { write } from 'fs';

/**
 * The image text alternative command. It is used to change the `alt` attribute of `<image>` elements.
 *
 * @extends module:core/command~Command
 */
export default class ImageTextAlternativeCommand extends Command {
	/**
	 * The command value: `false` if there is no `alt` attribute, otherwise the value of the `alt` attribute.
	 *
	 * @readonly
	 * @observable
	 * @member {String|Boolean} #value
	 */

	/**
	 * @inheritDoc
	 */
	refresh() {
		const element = this.editor.model.document.selection.getSelectedElement();

		// this.isEnabled = isImage( element );

		// if ( isImage( element ) && element.hasAttribute( 'alt' ) ) {

		// 	this.value = element.getAttribute( 'alt' );
			
		// } else {
		// 	this.value = false;
		// }

		this.isEnabled = true
	}

	/**
	 * Executes the command.
	 *
	 * @fires execute
	 * @param {Object} options
	 * @param {String} options.newValue The new value of the `alt` attribute to set.
	 */
	execute( options ) {
		console.log(options)
		const model = this.editor.model;
		const imageElement = model.document.selection.getSelectedElement();

		model.change( writer => {
			if(options.newValue === 0 || options.newValue === '0') writer.removeAttribute( 'width', imageElement );
			else writer.setAttribute( 'width', options.newValue, imageElement );
			console.log(writer)
		} );
	}
}
